var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9975 0.0205078C27.0032 0.0205078 0.0078125 27.0159 0.0078125 60.0102C0.0078125 93.0046 27.0032 120 59.9975 120C92.9919 120 119.987 93.0046 119.987 60.0102C119.987 27.0159 92.9919 0.0205078 59.9975 0.0205078Z",
    fill: "#D31104"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4223 49.1587C67.4223 53.6105 67.2574 57.76 66.9276 61.6072C66.5979 65.4544 66.1582 69.3565 65.6086 73.3137H56.2104C55.6608 69.3565 55.1937 65.4544 54.809 61.6072C54.4792 57.76 54.3143 53.6105 54.3143 49.1587V34.402H67.4223V49.1587ZM68.494 85.0201C68.494 87.4384 67.6971 89.307 66.1032 90.6261C64.5644 91.9451 62.8056 92.6046 60.8271 92.6046C58.8485 92.6046 57.0623 91.9451 55.4685 90.6261C53.9296 89.307 53.1602 87.4384 53.1602 85.0201C53.1602 82.6019 53.9296 80.7333 55.4685 79.4142C57.0623 78.0952 58.8485 77.4357 60.8271 77.4357C62.8056 77.4357 64.5644 78.0952 66.1032 79.4142C67.6971 80.7333 68.494 82.6019 68.494 85.0201Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDanger);
export default __webpack_public_path__ + "static/media/icon-danger.aa9ffba2.svg";
export { ForwardRef as ReactComponent };